export const isExploreSectionEnabled = (value) => {
  if (value === true) return true;
  if (value == null || value === false) return false;
  return Number(value) === 1;
};

const HANDBOOK_TAB = {
  category_name: "Handbooks",
  content_from_api: "get_handbook_list",
};

export const isHandbookCategory = (category) => {
  if (!category) return false;
  if (category.content_from_api === "get_handbook_list") return true;
  const name = String(category.category_name ?? category.name ?? "").toLowerCase();
  return name.includes("handbook") || name === "books";
};

export const getExploreCategoryKey = (category) => {
  if (isHandbookCategory(category)) return "books";
  return category?.id ?? category?.category_id;
};

export const mergeExploreCategories = (exploreList = [], storeList = []) => {
  const merged = [];
  const seen = new Set();

  const add = (category) => {
    if (!category) return;
    const key = isHandbookCategory(category)
      ? "books"
      : String(
          category.id ??
            category.category_id ??
            category.category_name ??
            ""
        ).trim();
    if (!key || seen.has(key)) return;
    seen.add(key);
    merged.push(category);
  };

  const primary = storeList.length ? storeList : exploreList;
  const secondary = storeList.length ? exploreList : storeList;
  primary.forEach(add);
  secondary.forEach(add);

  if (!merged.some(isHandbookCategory)) {
    add(HANDBOOK_TAB);
  }

  return merged;
};

export const normalizeStoreCatalog = (payload) => {
  if (!payload || typeof payload !== "object") {
    return { category_list: [], packages: [] };
  }

  const category_list = Array.isArray(payload.category_list)
    ? payload.category_list
    : [];
  const packages = Array.isArray(payload.packages)
    ? payload.packages
    : Array.isArray(payload.package)
      ? payload.package
      : [];

  return { category_list, packages };
};

export const packageMatchesCategory = (item, categoryKey) => {
  if (categoryKey == null) return false;
  const ids = item?.category_id;
  if (!Array.isArray(ids)) {
    return String(item?.category_id ?? item?.categoryId ?? "") === String(categoryKey);
  }
  return ids.some((category) => {
    const id =
      category && typeof category === "object"
        ? category.category_id ?? category.id
        : category;
    return String(id) === String(categoryKey);
  });
};
